<!-- TABLE Ở TRANG ADMIN -->
<nz-layout id="purchase-invoice-today">
  <!-- Phần header -->
  <div class="purchase-invoice-today-header">
    <div class="row p-0 m-0">
      <div class="col-6 p-0 m-0 d-flex align-items-center">
        <p class="title-admin">
          {{data.name}}
          <i class="bi bi-pencil-square ml-2" (click)="editNameObject(data)"></i>
        </p>
        <!-- Tìm kiếm -->
        <div class="search">
          <nz-input-group [nzSuffix]="suffixIconSearch">
            <input type="text" nz-input [placeholder]="'tim_kiem_ten_danh_muc' | translate"
              [(ngModel)]="searchNameCategory"
              (keyup.enter)="onSearchBlock(searchNameCategory)" />
          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span (click)="onSearchBlock(searchNameCategory)" nz-icon nzType="search"></span>
          </ng-template>
        </div>
      </div>
      <!-- Nút thêm danh mục vào frame -->
      <div class="col-6 p-0 m-0 d-flex align-items-center justify-content-end">
        <!-- Chọn ngôn ngữ -->
        <!-- <div class="mr-2">
          <app-select-language-config [isAdmin]="true"></app-select-language-config>
        </div> -->
        <button nzType="primary" class="_btn _btn_add d-flex align-items-center right-all-content mr-2" nz-button
          (click)="showModal()">
          {{'chon_danh_muc_hien_thi_trong_khung' | translate}}
        </button>
      </div>
    </div>
  </div>
  <!-- Phần table -->
  <div style="margin-top: 16px; height: 500px">
    <nz-table [nzScroll]="{ y: tableHeight }" 
      [nzLoading]="loadingBlock" 
      [nzData]="categoryShow" 
      #categoryShowTable nzShowSizeChanger
      [nzNoResult]="emptyResult"
      [nzShowPagination]="false" [nzFrontPagination]="false">
      <!-- table header -->
      <thead class="_thead">
        <tr>
          <th nzWidth="10%" nzAlign="center"><b>Ảnh</b></th>
          <th nzWidth="32.5%" nzAlign="left">
            <b>{{'ten_danh_muc' | translate}}</b>
            <span nz-icon (click)="handleSortBlock()" [nzType]=" isASC ? 'arrow-down' : 'arrow-up'"
              nzTheme="outline"></span>
          </th>
          <th nzWidth="32.5%" nzAlign="left"> <b>{{'thu_tu_hien_thi' | translate}}</b></th>
          <th nzWidth="25%" nzAlign="center"><b>{{'an_hien' | translate}}</b></th>
        </tr>
      </thead>
      <!-- table body -->
      <tbody>
        <ng-container *ngFor="let item of categoryShowTable.data">
          <tr>
            <td>
              <div class="image d-flex align-items-center justify-content-center">
                <img onerror="this.src='assets/root/images/system/icons/image_default.svg'" [src]="item.imgs? item.imgs[0]:''" [alt]="(item['name_' + functionService.defaultLanguage] ?? '')"
                  width="40px" height="40px">
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="margin-left: 20px; font-weight: 600;">
                <span>{{ item.array_step? generateSymBol(item.array_step) + (item['name_' + functionService.defaultLanguage] ?? '') : (item['name_' + functionService.defaultLanguage] ?? '') }}</span>
              </div>
            </td>
            <td>
              <div class="status">
                <label class="switch">
                  <input type="number" class="input" min="1" [(ngModel)]="item[this.data._id+'_ordinal_number']"
                    (blur)="updateOrder(item, item[this.data._id+'_ordinal_number'])" style="min-width: auto;height: 30px;">
                </label>
              </div>
            </td>
            <td nzAlign="center">
              <div class="status">
                <label class="switch">
                  <button nz-button nzType="primary" (click)="updateShowWeb(item, false)">Gỡ bỏ</button>
                </label>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    <ng-template #emptyResult>
      <nz-empty [nzNotFoundContent]="null"></nz-empty>
    </ng-template>

    <!-- Pagination Block -->
    <div *ngIf="categoryShow.length" class="pagination mt-3">
      <div class="pagination-list-button">
        <div class="page-start pagiItem" (click)="gotoPreviousPage()">{{'truoc' | translate }}</div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock >= 3 && pageCurrentBlock >= 3" (click)="transferFn(1)">
          1
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock > 3 && pageCurrentBlock > 3">
          ...
        </div>
        <div *ngFor='let page of pageShowChooseBlock ;let i = index'>
          <div class="page-number pagiItem" *ngIf="page <= totalPagesBlock && page > 0"
            [ngClass]="{'active': page == pageCurrentBlock}" (click)="transferFn(page)">
            {{page}}
          </div>
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock > 3 && pageCurrentBlock < totalPagesBlock-2">
          ...
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesBlock >= 3 && pageCurrentBlock <= totalPagesBlock-2"
          (click)="transferFn(totalPagesBlock)">
          {{totalPagesBlock}}
        </div>
        <div class="page-end pagiItem" (click)="gotoNextPage()">Sau</div>
        <button nz-popover [nzPopoverTitle]="('toi_da' | translate) + ' ' +  totalPagesBlock" [nzPopoverContent]="contentTemplate"
          class="page-go pagiItem" nzPopoverPlacement="top">
          {{'toi_trang' | translate }}
        </button>
        <!-- Số lượng danh mục trên/trang -->
        <nz-select [nzSize]="'large'"
          [(ngModel)]="limitBlock"
          (ngModelChange)="handleChangeLimitBlock()"
          nzPlaceHolder=""
          nzAllowClear="false"
          class="ml-2">
          <nz-option *ngFor="let n of numberPerPage" [nzValue]="n" [nzLabel]="n + '/Trang'"></nz-option>
        </nz-select>
      </div>
      <ng-template #contentTemplate>
        <div class="input-container">
          <div class="input-group">
            <input class="form-control" width="10rem" placeholder="{{'nhap_trang_can_toi' | translate }}" type="number" min="1" [max]="totalPagesBlock" 
              [(ngModel)]="pageGoto" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button"
                (click)="transferFn(pageGoto > totalPagesBlock ? totalPagesBlock : pageGoto < 1 ? 1 : pageGoto)">
                {{'toi' | translate}}
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</nz-layout>

<!-- MODAL CHỌN DANH MỤC VÀO BLOCK -->
<nz-modal nzWidth="70vw" [(nzVisible)]="showModalSelectData" nzTitle="{{'chon_danh_muc_hien_thi' | translate}}"
  (nzOnCancel)="showModalSelectData = false" (nzOnOk)="showModalSelectData = false">
  <ng-container *nzModalContent>
    <!-- Phần header -->
    <div class="row p-8 pt-0" style="padding: 15px; align-items:center; gap: 24px">
      <span class="title"><b>{{'danh_sach_danh_muc'| translate}}</b></span>
      <!-- Tìm kiếm -->
      <div class="search">
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input type="text" nz-input placeholder="{{'tim_kiem_ten_danh_muc'| translate}}"
            [(ngModel)]="searchNameCategoryModal"
            (keyup.enter)="onSearchModal(searchNameCategoryModal)" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span (click)="onSearchModal(searchNameCategoryModal)" nz-icon nzType="search"></span>
        </ng-template>
      </div>
      <!-- Chọn ngôn ngữ -->
      <!-- <div class="ml-2">
        <app-select-language-config [isAdmin]="true"></app-select-language-config>
      </div> -->
    </div>
    <!-- Phần table -->
    <nz-table [nzScroll]="{ y: '350px' }" 
     [nzLoading]="loadingModal" 
      [nzData]="listCategoryDB" 
      #tableSales
      nzShowSizeChanger
      [nzShowPagination]="false" [nzFrontPagination]="false">
      <thead class="_thead">
        <tr>
          <th nzWidth="10%" nzAlign="center"><b>Ảnh</b></th>
          <th nzWidth="65%" nzAlign="left">
            <b>{{'ten_danh_muc' | translate}}</b>
            <span nz-icon nzTheme="outline" 
              (click)="handleSortModal()" 
              [nzType]=" isASCModal ? 'arrow-down' : 'arrow-up'">
            </span>
          </th>
          <th nzWidth="25%" nzAlign="center"><b>{{'an_hien' | translate}}</b></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of tableSales.data; trackBy: trackByFn">
          <tr>
            <td>
              <div class="image d-flex align-items-center justify-content-center">
                <img onerror="this.src='assets/root/images/system/icons/image_default.svg'" [src]="item.imgs? item.imgs[0]:''" [alt]="(item['name_' + functionService.defaultLanguage] ?? '')"
                  width="40px" height="40px">
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-start text-start" style="margin-left: 20px; font-weight: 600;">
                <span>{{ item.array_step? generateSymBol(item.array_step) + (item['name_' + functionService.defaultLanguage] ?? '') : (item['name_' + functionService.defaultLanguage] ?? '') }}</span>
              </div>
            </td>
            <td nzAlign="center">
              <div class="status">
                <label class="switch">
                  <nz-switch [(ngModel)]="item[this.data._id+'_hidden']" (ngModelChange)="updateShowWeb(item,$event)"
                    [nzDisabled]="item[this.data._id+'_hidden']"></nz-switch>
                </label>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
    
    <!-- Pagination Modal -->
    <div *ngIf="listCategoryDB.length" class="pagination mt-3">
      <div class="pagination-list-button">
        <div class="page-start pagiItem" (click)="gotoPreviousPageModal()">{{'truoc' | translate }}</div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal >= 3 && pageCurrentModal >= 3" (click)="transferFnModal(1)">
          1
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal > 3 && pageCurrentModal > 3">
          ...
        </div>
        <div *ngFor='let page of pageShowChooseModal ;let i = index'>
          <div class="page-number pagiItem" *ngIf="page <= totalPagesModal && page > 0"
            [ngClass]="{'active': page == pageCurrentModal}" (click)="transferFnModal(page)">
            {{page}}
          </div>
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal > 3 && pageCurrentModal < totalPagesModal-2">
          ...
        </div>
        <div class="page-number pagiItem" *ngIf="totalPagesModal >= 3 && pageCurrentModal <= totalPagesModal-2"
          (click)="transferFnModal(totalPagesModal)">
          {{totalPagesModal}}
        </div>
        <div class="page-end pagiItem" (click)="gotoNextPageModal()">Sau</div>
        <button nz-popover [nzPopoverTitle]="'Tối đa ' +  totalPagesModal" [nzPopoverContent]="contentTemplate"
          class="page-go pagiItem" nzPopoverPlacement="top">
          {{'toi_trang' | translate }}
        </button>
        <!-- Số lượng danh mục trên/trang -->
        <nz-select [nzSize]="'large'"
          [(ngModel)]="limitModal"
          (ngModelChange)="handleChangeLimitModal()"
          nzPlaceHolder=""
          nzAllowClear="false"
          class="ml-2">
          <nz-option *ngFor="let n of numberPerPage" [nzValue]="n" [nzLabel]="n + '/Trang'"></nz-option>
        </nz-select>
      </div>
      <ng-template #contentTemplate>
        <div class="input-container">
          <div class="input-group">
            <input class="form-control" width="10rem" placeholder="{{'nhap_trang_can_toi' | translate }}" type="number" min="1" [max]="totalPagesModal" 
              [(ngModel)]="pageGoto" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button"
                (click)="transferFnModal(pageGoto > totalPagesModal ? totalPagesModal : pageGoto < 1 ? 1 : pageGoto)">
                {{'toi_trang' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>
</nz-modal>
